import type { LabelProps } from '@radix-ui/react-label';
import * as React from 'react';
import { Root } from '@radix-ui/react-label';

import { ctw } from '@/common/utils/ctw';

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
  <Root
    className={ctw(
      'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className,
    )}
    ref={ref}
    {...props}
  />
));

export { Label };
